import React from 'react';

const MemberSettings: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4">
      <div className="max-w-3xl mx-auto bg-white p-6 rounded-xl shadow-md">
        <h2 className="text-3xl font-bold text-gray-800 mb-4">Member Settings</h2>
        <p className="text-gray-600 mb-6">
          Manage your personal details, update your password, and adjust your preferences.
        </p>

        {/* Section: Profile Info */}
        <section className="space-y-6">
          <div>
            <h3 className="text-lg font-semibold text-gray-700">Personal Information</h3>
            <p className="text-sm text-gray-500 mb-2">Update your name, email, or contact info.</p>
            <div className="p-4 border rounded-md bg-gray-50 text-sm text-gray-500">
              {/* TODO: Add personal info form */}
              Profile update form goes here
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-gray-700">Change Password</h3>
            <p className="text-sm text-gray-500 mb-2">Secure your account by changing your password.</p>
            <div className="p-4 border rounded-md bg-gray-50 text-sm text-gray-500">
              {/* TODO: Add password change form */}
              Password change form goes here
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default MemberSettings;

